import { render, staticRenderFns } from "./PracticePassResult.vue?vue&type=template&id=16771aa7&"
import script from "./PracticePassResult.vue?vue&type=script&lang=ts&"
export * from "./PracticePassResult.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports